/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StraightenOutlineIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Straighten Outline',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33.5 14H.5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h33a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5Zm-11.286 2 .018.968C22.232 19.05 18.9 20.1 17 20.1s-5.25-1.05-5.25-3.107V16ZM6 26H2V16h4Zm20 0H8V16h2v1c0 3 3.134 5 7 5s7-2 7-5v-1h2Zm6 0h-4V16h4Z"
    />
    <circle cx="7" cy="11" r="1.3" />
    <circle cx="27" cy="11" r="1.3" />
    <circle cx="17" cy="5" r="1.3" />
    <circle cx="11" cy="7" r="1.3" />
    <circle cx="23" cy="7" r="1.3" />
  </svg>`;
};
